"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

function EditorText(props) {
  var block = props.block,
      RenderStyle = props.renderStyle,
      RenderTextFragment = props.renderTextFragment;
  var offset = 0;
  var textFragments = null;

  if (block.value.length > 0) {
    var fragments = block.fragments;
    var _offset = 0;
    textFragments = fragments.map(function (fragment) {
      var fragmentProps = {
        key: "".concat(block.blockKey, "-").concat(_offset),
        'data-block-key': block.blockKey,
        'data-fragment-start': _offset,
        'data-fragment-end': _offset + fragment.text.length
      };
      var textFragment = fragment.styles.reduce(function (children, val) {
        if (RenderStyle != null) {
          return react_1.default.createElement(RenderStyle, {
            key: "".concat(fragmentProps.key, "-").concat(val),
            style: val
          }, children);
        } else {
          return children;
        }
      }, react_1.default.createElement("span", Object.assign({}, fragmentProps, {
        key: "fragment-".concat(block.blockKey, "-").concat(_offset)
      }), fragment.text || react_1.default.createElement("br", null)));

      if (RenderTextFragment) {
        textFragment = react_1.default.createElement(RenderTextFragment, {
          entity: fragment.entity,
          key: "entity-".concat(block.blockKey, "-").concat(_offset)
        }, textFragment);
      }

      _offset += fragment.text.length;
      return textFragment;
    });
  } else {
    textFragments = react_1.default.createElement("span", {
      key: "text-fragments-".concat(block.blockKey),
      "data-block-key": block.blockKey,
      "data-fragment-start": 0,
      "data-fragment-end": 0
    }, react_1.default.createElement("br", null));
  }

  return react_1.default.createElement(react_1.default.Fragment, null, textFragments);
}

exports.default = EditorText;